import { takeLatest, fork, put, all, call } from 'redux-saga/effects'

import i18n from 'i18n'
import { jobsAPI } from '../../../../api'
import { jobMySpecificList } from './slice'
import { RequestUtils } from 'utils'

export function* getList({ payload: { params } }) {
  try {
    let requestParams = {
      includes: ['jobType', 'profileExperienceYear'],
    }

    requestParams = RequestUtils.getMapRequestParams(params, requestParams)

    const response = yield call(jobsAPI.getMyJobs, requestParams)

    const { data } = response

    const {
      meta: { current_page, last_page },
    } = data

    if (current_page && last_page && current_page > last_page) {
      yield put(
        jobMySpecificList.getList({
          params: {
            ...params,
            page: last_page,
          },
        })
      )
    } else {
      yield put(jobMySpecificList.getListSuccess(data))
    }
  } catch (error) {
    const message = error.response?.data?.message || i18n.t('error')
    yield put(jobMySpecificList.getListError(message))
  }
}

export function* watchGetList() {
  yield takeLatest(jobMySpecificList.getList, getList)
}

function* listSaga() {
  yield all([fork(watchGetList)])
}

export default listSaga
